import { createAction } from "redux-actions"

import { NOTIFICATION_SUCCESS_MESSAGE } from "../constants/ActionTypes"

export const createSuccessNotification = createAction<string>(
  NOTIFICATION_SUCCESS_MESSAGE
)
